import {
  useSensors,
  useSensor,
  PointerSensor,
  KeyboardSensor,
  DragEndEvent,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';
import { Group } from './types';

interface UseDragAndDropProps {
  groups: Group[];
  setGroups: (groups: Group[]) => void;
  calculateReorderedGroups: (
    groups: Group[],
    activeId: string,
    overId: string
  ) => Group[] | null;
  onSave: (groups: Group[]) => void;
}

export const useDragAndDrop = ({
  groups,
  setGroups,
  calculateReorderedGroups,
  onSave,
}: UseDragAndDropProps) => {
  // Setup drag-and-drop sensors
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  // Handle drag end event
  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const newGroups = calculateReorderedGroups(
        groups,
        active.id as string,
        over.id as string
      );

      if (newGroups) {
        // Update local modal state with calculated groups
        setGroups(newGroups);

        // Save to backend
        onSave(newGroups);
      }
    }
  };

  return {
    sensors,
    handleDragEnd,
  };
};
